module.exports = __webpack_public_path__ + "img/ezoic_cache.457d9d20.png";